import {GuidebooksApi} from '../api';
import {FetcherSettings} from '../api/apiClient';

class GuidebooksService {
  private readonly guidebooksApi: GuidebooksApi;

  constructor() {
    this.guidebooksApi = new GuidebooksApi();
  }

  getGuidebooks(reservationId: string, resolverSettings?: FetcherSettings) {
    return this.guidebooksApi.getGuidebooks(reservationId, resolverSettings);
  }

  getGuidebook(
    guidebookId: string,
    reservationId: string,
    resolverSettings?: FetcherSettings,
  ) {
    return this.guidebooksApi.getGuidebook(guidebookId, reservationId, resolverSettings);
  }

  getGuidebooksByGroup(groupId: string, resolverSettings?: FetcherSettings) {
    return this.guidebooksApi.getGuidebooksByGroup(groupId, resolverSettings);
  }
}

export {GuidebooksService};
